export default __webpack_public_path__ + "static/ThinkstockPhotos-519436783_article-76c0ca9858433487740b6d4e7f4f2112.jpg";